module.exports = __webpack_public_path__ + "static/group2_2-1b76ea362cd3fe9181eceeb3962543af.webp";